import { Spinner } from "../../components/Loading/Spinner";
import SuscrPickOrg from "../../components/Profile/SuscrPickOrg";
import ConfirmDeleteModal from "../../components/Table/Roles/ConfirmDeleteModal";
import RolesPanel from "../../components/Table/Roles/RolesPanel";
import { useSuperAdminRoles } from "../../context/SuperAdmin/RolesContext";
import { Grid, Typography } from "@mui/material";
import { useAuthContext } from "../../hooks/Auth";

const RolesPage = () => {
  const { organizaciones, selectedOrg, handleSelectChange, isLoadingOrgs } =
    useSuperAdminRoles();
  const { canAccess } = useAuthContext();

  const isSuperAdmin = canAccess("view:roles");

  return (
    <Grid
      container
      spacing={4}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        pt: 3,
      }}
    >
      {/* Título */}
      <Grid item>
        <Typography variant={"h4"} sx={{ color: "#005559", fontSize: "30px" }}>
          <b>{isSuperAdmin ? "Organizaciones" : "Organización"}</b> | Roles
        </Typography>
      </Grid>

      {isLoadingOrgs ? (
        <Grid item>
          <Spinner msg="Cargando por favor espere..." />
        </Grid>
      ) : (
        <>
          {/* Seleccionar organizacion */}
          {isSuperAdmin && (
            <Grid item>
              <SuscrPickOrg
                organizaciones={organizaciones}
                selectedOrg={selectedOrg ? selectedOrg : ""}
                handleChange={handleSelectChange}
                isLoading={isLoadingOrgs}
              />
            </Grid>
          )}

          {/* Menú de roles */}
          {selectedOrg && <RolesPanel />}
        </>
      )}
      {/* Confirmar eliminación */}
      {canAccess("delete:role") && (
        <Grid item>
          <ConfirmDeleteModal />
        </Grid>
      )}
    </Grid>
  );
};

export default RolesPage;
